/* eslint-disable camelcase */
import router from '../../router';
import Vuetify from '../../plugins/vuetify';
import { getAll, graphQL } from '../../api';

let users_table;
let client_table;
if (process.env.NODE_ENV === 'development') {
  users_table = process.env.VUE_APP_DEV_USERS_TABLE;
  client_table = process.env.VUE_APP_DEV_CLIENT_TABLE;
} else {
  users_table = process.env.VUE_APP_PROD_USERS_TABLE;
  client_table = process.env.VUE_APP_PROD_CLIENT_TABLE;
}

// initial users state
const state = {
  currentClient: {
    groups: [],
  },
  adminsAndUsers: [],
  allClients: [],
  allUsers: [],
  editUser: false,
  deleteUser: false,
  userError: null,
  clientIsSet: false,
  clientGroupsAreSet: false,
  currentUser: {},
  clientCreated: false,
  clientEdit: {},
  clientLogo: '',
  userGroups: [],
  userType: 'user',
  userFilterOptions: {
    first_name: {
      items: [],
      label: 'First Name',
      model: 'first_name',
    },
    last_name: {
      items: [],
      label: 'Last Name',
      model: 'last_name',
    },
    email: {
      items: [],
      label: 'Email',
      model: 'email',
    },
    phone_number: {
      items: [],
      label: 'Phone Number',
      model: 'phone_number',
    },
  },
  newInvite: false,
  queryParams: {
    page: 1,
  },
  states: [
    'AL',
    'AK',
    'American Samoa',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'District of Columbia',
    'FL',
    'GA',
    'Guam',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'Marshall Islands',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'OH',
    'OK',
    'OR',
    'PN',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'Virgin Island',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
  ],
};

// getters
const getters = {
  getCurrentClient: state => state.currentClient,
  getCurrentUser: state => state.currentUser,
  getAllClients: state => state.allClients,
  getAllUsers: state => state.allUsers,
  getStates: state => state.states,
  getQueryParams(state) {
    return state.queryParams;
  },
  getNewInvite(state) {
    return state.newInvite;
  },
  getUserGroups(state) {
    return state.userGroups;
  },
  getUserError(state) {
    return state.userError;
  },
  getUserFilterOptions(state) {
    return state.userFilterOptions;
  },
  getEditUser(state) {
    return state.editUser;
  },
  getDeleteUser(state) {
    return state.deleteUser;
  },
  getClientLogo(state) {
    return state.clientLogo;
  },
  getCurrentClientGroups(state) {
    return state.currentClient.groups;
  },
  getClientIsSet(state) {
    return state.clientIsSet;
  },
  getClientGroupsAreSet(state) {
    return state.clientGroupsAreSet;
  },
  getUserType(state) {
    return state.userType;
  },
  getAdminsAndUsers(state) {
    return state.adminsAndUsers;
  },
};

// actions
const actions = {
  getClientData: async ({ dispatch }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/client?query=${encodeURIComponent(
        `{get(type_name: "direct", id: ${payload.id}){ client_name, uuid, error, success }}`
      )}`,
      payload
    )
      .then(res => {
        dispatch('getClientGroups', {
          clientParam: router.history.current.params.client,
          data: res.data.getClient,
        });
        // commit("navigation/updateNavRoutes", `/${res.data.getClient.name}`);
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getClientGroups: async ({ commit, rootGetters, dispatch }, payload) => new Promise((resolve, reject) => {
    if (payload.client.client_name === 'shark') {
      dispatch('getSharkClientGroups', payload);
    } else {
      const user_groups =
          rootGetters['account/getCurrentUser'].group_id &&
          rootGetters['account/getCurrentUser'].group_id[0];
      let group;
      if (user_groups && user_groups !== 'all') {
        group = { uuid: user_groups };
        group = JSON.stringify(group).replace(/"([^"]+)":/g, '$1: ');
      }
      const callString = `{
            group_name, 
            uuid,
            area_id,
            lat,
            lng,
            address{
              city
            },
            error, 
            success
          }`;
      let query = `{get(type_name: "group", 
          table_name:"${payload.client.table_name}", `;
      if (group) {
        query = query.concat(`group: ${group},`);
      } else {
        query = query.concat('index: "all-index",');
      }
      query = query.concat(`)${callString}}`);
      getAll(`/group?query=${encodeURIComponent(query)}`)
        .then(res => {
          dispatch('getClientRounds');
          commit('setClientGroups', res.data.data.get);
          const groupLocations = [];
          res.data.data.get.map(group => {
            if (group.lat !== null && group.lng !== null) {
              groupLocations.push({
                position: {
                  lat: group.lat,
                  lng: group.lng,
                },
                group_id: group.uuid,
                infoOpen: false,
              });
            }
          });
          commit('maps/setGroupLocations', groupLocations, { root: true });
          commit('screens/setScreenGroupOptions', [], { root: true });
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    }
  }),
  getSharkClientGroups: async ({ commit, rootGetters, dispatch }, payload) => new Promise((resolve, reject) => {
    const callString = `{
          group_name, 
          uuid,
          lat,
          lng,
          city,
          last_activity,
          launch_mode
        }`;

    graphQL({
      query: `
            query {
              getAllGroups(
                itemsPerPage: 10000
                page: 1
              ) ${callString}
            }
          `,
    })
      .then(res => {
        dispatch('getClientRounds');
        commit('setClientGroups', res.data.data.getAllGroups);
        commit('reports/setSharkAllGroups', res.data.data.getAllGroups, {
          root: true,
        });
        commit('filters/setHomeFilterOptions', res.data.data.getAllGroups, {
          root: true,
        });
        const filter = rootGetters['filters/getFilter'];
        const groupLocations = [];
        res.data.data.getAllGroups.map(group => {
          if (filter.group && filter.group === group.uuid
            && (group.lat !== null && group.lng !== null)) {
            groupLocations.push({
              position: {
                lat: group.lat,
                lng: group.lng,
              },
              group_id: group.uuid,
              infoOpen: false,
            });
          } else if (!filter.group && group.lat !== null && group.lng !== null) {
            groupLocations.push({
              position: {
                lat: group.lat,
                lng: group.lng,
              },
              group_id: group.uuid,
              infoOpen: false,
            });
          }
        });
        commit('maps/setGroupLocations', groupLocations, { root: true });
        commit('screens/setScreenGroupOptions', [], { root: true });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getClientRounds: async ({ commit, rootGetters }) => new Promise((resolve, reject) => {
    const clientTable = rootGetters['account/getCurrentClient'].table_name;
    getAll(
      `/round?query=${encodeURIComponent(
        `{get(type_name: "round", 
            table_name:"${clientTable}",  
            index: "all-index"
          ){
            uuid,
            screen_id, 
            imei,
            gpsi_car_number,
            gpsi_car_id,
            mdn,
            course_launch_intent_mode,
            error, 
            success
          }}`
      )}`
    )
      .then(res => {
        commit('setClientRounds', res.data.data.get);
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getUserData: async ({ commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/user?query=${encodeURIComponent(
        `{auth(type_name: "user", table_name: "${users_table}", user: {email: "${payload.email}", password: "${payload.password}"}, 
          ){
            uuid,
            user_name, 
            email,
            type_name,
            client_id,
            group_id,
            location,
            group_id,
            address{
              address_1,
              address_2,
              state,
              zip,
              city,
              country,
              state,
              zip
            },
            contact{
              contact_name,
              phone,
              email
            },
            password,
            success, 
            error
          }}`
      )}`
    )
      .then(res => {
        if (res.data.data.auth.email) {
          commit('setCurrentUser', res.data.data.auth);
          resolve(res);
        } else {
          reject(res.error);
        }
      })
      .catch(error => {
        reject(error);
      });
  }),
  getAdminsAndUsers: async ({ commit }) => {
    const users = await getAll(
      `/user?query=${encodeURIComponent(
        `{get(type_name: "user", 
          table_name:"${users_table}", 
          index: "all-index"
        ){
          uuid,
          user_name, 
          contact{
            contact_name,
            phone,
            email
          },
          error, 
          success
        }}`
      )}`
    );
    const admins = await getAll(
      `/user?query=${encodeURIComponent(
        `{get(type_name: "admin", 
          table_name:"${users_table}", 
          index: "all-index"
        ){
          uuid,
          user_name, 
          contact{
            contact_name,
            phone,
            email
          },
          error, 
          success
        }}`
      )}`
    );
    const adminsAndUsers = [...users.data.data.get, ...admins.data.data.get];
    commit('setAdminsAndUsers', adminsAndUsers);
  },
  getAllUsers: async ({ commit, getters }) => new Promise((resolve, reject) => {
    getAll(
      `/user?query=${encodeURIComponent(
        `{get(type_name: "${getters.getUserType}", 
            table_name:"${users_table}", 
            index: "all-index"
          ){
            uuid,
            user_name, 
            email,
            client_id,
            type_name,
            password,
            group_id,
            address{
              address_1,
              address_2,
              state,
              zip,
              city,
              country,
              state,
              zip
            },
            location,
            contact{
              contact_name,
              phone,
              email
            },
            error, 
            success
          }}`
      )}`
    )
      .then(res => {
        commit('setAllClients', {
          data: res.data.data.get,
          name: '/users',
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  getAllClients: async ({ dispatch, commit }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/client?query=${encodeURIComponent(
        `{get(
              type_name: "direct"
            ){ 
              client_name, 
              table_name,
              uuid, 
              style_attrs{
                primary_color,
                secondary_color
              },
              address{
                address_1,
                address_2,
                state,
                zip,
                city,
                country
              },
              contact{
                contact_name,
                phone,
                email
              },
              error, 
              success 
            }}`
      )}`
    )
      .then(res => {
        dispatch('getUserData', {});
        commit('setAllClients', {
          data: res.data.data.get,
          name: payload,
        });
        state.clientIsSet = false;
        let clientName = null;
        if (
          router.history.current.params.client &&
            state.currentUser.client_id.includes(
              router.history.current.params.client
            )
        ) {
          clientName = router.history.current.params.client;
        } else if (
          localStorage.getItem('currentClient') &&
            state.currentUser.client_id.includes(
              localStorage.getItem('currentClient')
            )
        ) {
          clientName = localStorage.getItem('currentClient');
        } else {
          clientName = state.currentUser.client_id[0];
        }
        const newClient = res.data.data.get.find(
          client => client.client_name.toLowerCase().replace(/\s/g, '') ===
              clientName.toLowerCase().replace(/\s/g, '')
        );
        dispatch('getClientGroups', {
          client: newClient,
          data: res.data.data.get.length ? res.data.data.get[0] : {},
        });
        commit('setCurrentClient', {
          clientParam: clientName,
          data: newClient,
        });
        // dispatch("home/getHomePageData", newClient, { root: true });
        commit('navigation/updateNavRoutes', `/${clientName}`, {
          root: true,
        });
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  checkCurrentClient: async ({ commit, state, dispatch }) => new Promise(resolve => {
    if (
      state.currentClient.client_name &&
        router.history.current.params.client &&
        router.history.current.params.client
          .toLowerCase()
          .replace(/\s/g, '') !==
          state.currentClient.client_name.toLowerCase().replace(/\s/g, '')
    ) {
      const newClient = state.allClients.find(
        client => client.client_name.toLowerCase().replace(/\s/g, '') ===
            router.history.current.params.client
              .toLowerCase()
              .replace(/\s/g, '')
      );
      dispatch('getClientGroups', {
        client: newClient,
        data: {},
      });
      dispatch(
        'groups/acquireGroups',
        { page: 1, itemsPerPage: 10 },
        { root: true }
      );
      commit(
        'navigation/updateNavRoutes',
        `/${router.history.current.params.client}`,
        {
          root: true,
        }
      );
    }
    resolve();
  }),
  changeClient: async ({ commit, dispatch }, payload) => {
    Object.keys(window.localStorage).map(k => {
      if (k.match(/filters/)) {
        window.localStorage.removeItem(k);
      }
    });
    return new Promise(resolve => {
      commit(
        'filters/setGroupsFilterOptions',
        {
          interfaces: [],
          cities: [],
          adSchedules: [],
          active: [],
        },
        { root: true }
      );
      commit(
        'navigation/updateNavRoutes',
        `/${payload.toLowerCase().replace(/\s/g, '')}`,
        {
          root: true,
        }
      );
      const newClient = state.allClients.find(
        client => client.client_name.toLowerCase().replace(/\s/g, '') ==
          payload.toLowerCase().replace(/\s/g, '')
      );
      commit('setCurrentClient', {
        clientParam: payload,
        data: newClient,
      });
      dispatch('getClientGroups', {
        client: newClient,
        data: {},
      });
      dispatch(
        'groups/acquireGroups',
        { page: 1, itemsPerPage: 10 },
        { root: true }
      );
      dispatch('home/getHomePageData', newClient, { root: true });
      resolve();
    });
  },
  updateClient: async ({ commit }, payload) => new Promise((resolve, reject) => {
    const data = JSON.stringify(payload.data).replace(/"([^"]+)":/g, '$1: ');
    getAll(
      `/client?query=${encodeURIComponent(
        `mutation{update(client: ${data}, table_name: "${client_table}", type_name: "direct"){ client_name, uuid, error, success }}`
      )}`
    )
      .then(res => {
        commit('clientEdit', res);
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  updateUser: async ({ commit, dispatch, rootGetters }, payload) => new Promise((resolve, reject) => {
    const data = JSON.stringify(payload.data).replace(/"([^"]+)":/g, '$1: ');
    getAll(
      `/user?query=${encodeURIComponent(
        `mutation{update(
            ${payload.typeName}: ${data}, 
            table_name: "${users_table}", 
            type_name: "${payload.typeName}"
          ){
            uuid,
            user_name, 
            email,
            type_name,
            group_id,
            client_id,
            address{
              address_1,
              address_2,
              city,
              country,
              state,
              zip
            },
            location,
            contact{
              contact_name,
              phone,
              email
            },
            password,
            success, 
            error
          }}`
      )}`
    )
      .then(res => {
        if (payload.setCurrentUser === true) {
          commit('setCurrentUser', res.data.data.update);
        }
        dispatch('getAllUsers', payload.typeName);
        if (res.data.error) {
          commit('setUserError', 'An Error Occurred');
        } else {
          commit('setUserError', 'User Updated');
          dispatch('getClientGroups', {
            client: rootGetters['account/getCurrentClient'],
            data: {},
          });
        }
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  deleteClient: async payload => new Promise((resolve, reject) => {
    // remove(payload.route + payload.id)
    getAll(
      `/client?query=${encodeURIComponent(
        `mutation{delete(type_name: "direct", id: ${payload.uuid}){ client_name, uuid, error, success }}`
      )}`,
      payload
    )
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  createClient: async ({ commit }, payload) => new Promise((resolve, reject) => {
    payload = JSON.stringify(payload).replace(/"([^"]+)":/g, '$1: ');
    getAll(
      `/client?query=${encodeURIComponent(
        `mutation{create(
            type_name: "direct", 
            client: ${payload}
          ){ 
            client_name, 
            uuid, 
            error, 
            success 
          }}`
      )}`
    )
      .then(res => {
        commit('setClientCreated', true);
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
  createUser: async ({ commit }, payload) => new Promise((resolve, reject) => {
    const data = JSON.stringify(payload.data).replace(/"([^"]+)":/g, '$1: ');
    getAll(
      `/user?query=${encodeURIComponent(
        `mutation{update(
            type_name: "user", 
            user: ${data}, 
            table_name: "${users_table}"
          ){
            user_name
            error, 
            success 
          }}`
      )}`
    )
      .then(res => {
        res;
        getAll(
          `/user?query=${encodeURIComponent(
            `{reset_password(user:{email: "${payload.data.email}", password: "${payload.password}", password_code: "${payload.code}"}){user_name}}`
          )}`
        );
        commit('setUserError', null);
      })
      .catch(error => {
        commit('setUserError', error.message);
        reject(error);
      });
  }),
  deleteUser: async ({ dispatch }, payload) => new Promise((resolve, reject) => {
    getAll(
      `/user?query=${encodeURIComponent(
        `mutation{delete(type_name: "${payload.type}", uuid: "${payload.id}", table_name: "${users_table}"){
            uuid, 
            error, 
            success 
          }}`
      )}`
    )
      .then(res => {
        dispatch('getAllUsers', payload.userType);
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  }),
};

// mutations
const mutations = {
  setCurrentClient(state, payload) {
    if (payload === null) {
      state.currentClient = {
        groups: [],
      };
      Vuetify.framework.theme.currentTheme.primary = '1876D2';
    }
    let newClient = null;
    if (payload && payload.clientParam && state.allClients) {
      newClient = state.allClients.find(
        client => client.client_name.toLowerCase().replace(/\s/g, '') ===
          payload.clientParam.toLowerCase().replace(/\s/g, '')
      );
    }
    if (newClient) {
      newClient.groups = payload.data.groups;
      const clientName = newClient.client_name.toLowerCase().replace(/\s/g, '');
      if (
        localStorage.getItem('currentClient') !==
          payload.clientParam.toLowerCase().replace(/\s/g, '') ||
        !router.history.current.params.client
      ) {
        router.push(`/${clientName}/home`).catch(err => {
          err;
        });
      }
      Vuetify.framework.theme.currentTheme.primary =
        newClient.style_attrs.primary_color;
      Vuetify.framework.theme.currentTheme.secondary =
        newClient.style_attrs.secondary_color;
      newClient.groups = state.currentClient.groups;
      state.currentClient = newClient;
      state.clientLogo = newClient.logo_url;
      localStorage.setItem('currentClient', clientName);
    } else if (payload && !newClient) {
      const clientName = payload.data.client_name
        ? payload.data.client_name.toLowerCase().replace(/\s/g, '')
        : 'no client';
      if (localStorage.getItem('currentClient') !== clientName) {
        router.push(`/${clientName}/home`).catch(err => {
          err;
        });
      }
      payload.data.groups = state.currentClient.groups;
      state.currentClient = payload.data;
      state.clientLogo = payload.data.logo_url;
      Vuetify.framework.theme.currentTheme.primary = payload.data.primary_color;
      Vuetify.framework.theme.currentTheme.secondary =
        newClient.style_attrs.secondary_color;
      localStorage.setItem('currentClient', clientName);
      if (router.history.current.name === 'Login') {
        router.push(`/${clientName}/home`).catch(err => {
          err;
        });
      }
    }
    state.clientIsSet = true;
  },
  setCurrentUser(state, payload) {
    // if (payload.groups) {
    //   let valueArray = payload.groups.split(",");
    //   let allGroups = [];
    //   valueArray.map(group => {
    //     let groupObject = {};
    //     var tempGroup = group.split("=");
    //     groupObject.name = tempGroup[0];
    //     groupObject.id = tempGroup[1];
    //     allGroups.push(groupObject);
    //   });
    //   state.userGroups = allGroups;
    // }
    state.currentUser = payload;
  },
  setClientLogo(state, payload) {
    state.clientLogo = payload;
  },
  setUserError(state, payload) {
    state.userError = payload;
  },
  setAllClients(state, payload) {
    if (payload.name === '/users') {
      state.allUsers = payload.data;
    } else {
      state.allClients = payload.data;
    }
  },
  setClientCreated(state, payload) {
    state.clientCreated = payload;
  },
  setQueryParams(state, payload) {
    state.queryParams = payload;
  },
  setNewInvite(state, payload) {
    state.newInvite = payload;
  },
  setEditUser(state, payload) {
    state.editUser = payload;
  },
  setDeleteUser(state, payload) {
    state.deleteUser = payload;
  },
  clientEdit(state, payload) {
    state.clientEdit = payload;
  },
  setClientGroups(state, payload) {
    state.currentClient.groups = payload;
    state.clientGroupsAreSet = true;
  },
  setError(state, payload) {
    state.error = payload;
  },
  setUserType(state, payload) {
    state.userType = payload;
  },
  setClientRounds(state, payload) {
    state.currentClient.rounds = payload;
  },
  setAdminsAndUsers(state, payload) {
    state.adminsAndUsers = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
